import { bootstrapApplication } from "@angular/platform-browser";
import { BrowserUtils } from "@azure/msal-browser";

import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

/**
 * MSAL acquires tokens silently (`ssoSilent` / `acquireTokenSilent`) inside a
 * hidden iframe whose `src` is the app's `redirectUri` ("/"). That iframe loads
 * this same SPA. We must NOT bootstrap Angular inside it: doing so re-runs the
 * auth initializer, rewrites the URL — stripping the response hash the parent
 * window's MSAL is polling for — and fires another redirect, which throws
 * `block_iframe_reload`. The net effect is the top window sits blank until
 * `ssoSilent` times out (~10s), so the app appears to "not start".
 *
 * When loaded inside an iframe carrying an MSAL auth-response hash, do nothing
 * and let the parent window read the hash and tear the iframe down. A plain
 * (non-auth) embed still bootstraps normally.
 */
function isMsalSilentIframe(): boolean {
  if (!BrowserUtils.isInIframe()) {
    return false;
  }
  const hash = window.location.hash;
  return (
    hash.includes("code=") ||
    hash.includes("error=") ||
    hash.includes("id_token=") ||
    hash.includes("access_token=") ||
    hash.includes("state=")
  );
}

if (!isMsalSilentIframe()) {
  bootstrapApplication(AppComponent, appConfig)
.catch((err) => console.error(err));
}
